import { z } from 'zod/v4';

import { createdAtSchemaLegacy, styleBagSchema } from '../../../common/schemas/legacy';

import { eduLoginButtonLegacyDefaultDataSchema } from './data';

/**
 * Default-placement legacy EDU-login button envelope.
 *
 * `type` is `z.literal('default').optional()` so the zod discriminated union in
 * `./entity.ts` can dispatch on `type` and fall through to this branch when the
 * field is missing. The `name` discriminator is `'edu-login-button'` — this is
 * what makes the widget a genuinely independent entity rather than a button
 * alias.
 */
export const eduLoginButtonLegacyDefaultV0Schema = z.object({
    id: z.string(),
    name: z.literal('edu-login-button'),
    columnId: z.string(),
    structureId: z.string().nullish(),
    displayId: z.string().nullish(),
    createdAt: createdAtSchemaLegacy,
    type: z.literal('default').optional(),
    data: eduLoginButtonLegacyDefaultDataSchema,
    styles: styleBagSchema.nullish(),
    mobileStyles: styleBagSchema.nullish(),
});
